export const CustomDropdownIcon = (props) => (
    <>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        style={{ marginRight: "10px", marginTop: "3px", pointerEvents: "none" }} 
        {...props} 
    >
        <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="#A4B0C0"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        />
    </svg>
    </>
);